import values from 'lodash/fp/values'
import PropTypes from 'prop-types'


const constants = {
    DEFAULT: '',
    PUSHSUCCESS: 'Push notification has been resent',
    SUCCESS: 'Verification Code has been resent'
}

export const types = PropTypes.oneOf(values(constants))

export default constants
